import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Check, UserPlus } from "lucide-react";
import { initials, useWorkMeta } from "@/lib/work";
import { cn } from "@/lib/utils";

export function Avatar({ id, size = "sm", className }) {
  const { person } = useWorkMeta();
  const p = person(id);
  const dim = size === "xs" ? "w-5 h-5 text-[9px]" : "w-6 h-6 text-[10px]";
  return <span title={p?.name || "Unassigned"} className={cn("rounded-full inline-flex items-center justify-center font-semibold text-white flex-shrink-0", dim, p ? "bg-slate-700" : "bg-slate-200 text-slate-500", className)}>{p ? initials(p.name) : "?"}</span>;
}

export function AvatarStack({ ids = [], max = 3 }) {
  if (!ids.length) return <span className="text-xs text-slate-300">—</span>;
  return <span className="inline-flex -space-x-1.5">{ids.slice(0, max).map((id) => <Avatar key={id} id={id} className="ring-2 ring-white" />)}{ids.length > max && <span className="w-6 h-6 rounded-full bg-slate-100 text-[10px] text-slate-500 inline-flex items-center justify-center ring-2 ring-white">+{ids.length - max}</span>}</span>;
}

export function PeoplePicker({ value = [], onChange, single = false, label = "Assign", testid = "people-picker", children }) {
  const { people } = useWorkMeta();
  const [open, setOpen] = useState(false);
  const toggle = (id) => {
    if (single) { onChange(value.includes(id) ? [] : [id]); setOpen(false); return; }
    onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children || <button type="button" className="inline-flex items-center gap-1.5 text-xs text-slate-500 hover:text-slate-800 border border-dashed border-slate-300 rounded-full px-2.5 py-1" data-testid={testid}><UserPlus className="w-3.5 h-3.5" /> {label}</button>}</PopoverTrigger>
      <PopoverContent className="w-64 p-0" align="start">
        <Command><CommandInput placeholder="Search people…" data-testid={`${testid}-search`} /><CommandList><CommandEmpty>No one found.</CommandEmpty><CommandGroup>
          {people.map((p) => <CommandItem key={p.id} onSelect={() => toggle(p.id)} data-testid={`${testid}-option-${p.id}`}><Avatar id={p.id} className="mr-2" /><span className="flex-1 truncate">{p.name}</span>{value.includes(p.id) && <Check className="w-4 h-4 text-teal-600" />}</CommandItem>)}
        </CommandGroup></CommandList></Command>
      </PopoverContent>
    </Popover>);
}
